import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PageTracker from "./components/PageTracker";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Products from "./pages/Products";
import ProductCategory from "./pages/ProductCategory";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminCollections from "./pages/admin/AdminCollections";
import AdminEnquiries from "./pages/admin/AdminEnquiries";
import AdminContent from "./pages/admin/AdminContent";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminBackup from "./pages/admin/AdminBackup";
import { I18nProvider } from "./i18n";
import { SiteDataProvider } from "./siteData";
import { Toaster } from "./components/ui/toaster";

const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-[#FAFAFA] overflow-x-hidden">
      <HelmetProvider>
      <I18nProvider>
        <SiteDataProvider>
          <BrowserRouter>
          <ScrollToTop />
          <PageTracker />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:key" element={<ProductCategory />} />
              <Route path="/3d-panels" element={<Navigate to="/products" replace />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:slug" element={<ProjectDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            <Route path="/admin/giris" element={<AdminLogin />} />
            <Route path="/admin/login" element={<Navigate to="/admin/giris" replace />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/projeler" replace />} />
              <Route path="projeler" element={<AdminProjects />} />
              <Route path="koleksiyonlar" element={<AdminCollections />} />
              <Route path="mesajlar" element={<AdminEnquiries />} />
              <Route path="analitik" element={<AdminAnalytics />} />
              <Route path="yedek" element={<AdminBackup />} />
              <Route path="gorseller" element={<AdminMedia />} />
              <Route path="icerik/:section" element={<AdminContent />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
        </SiteDataProvider>
      </I18nProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
